import { defaultCurrencyId } from '@/creditflowresearch/ui/components/portfolioMonitor/constants';

export const defaultPositionValues = {
  currencyId: defaultCurrencyId,
  positionSize: '',
  pricePaid: '',
  datePurchased: null,
  bond: {
    dealId: null,
    trancheId: null,
    customBondName: null,
  },
};
